export const courseCategories = [
  {
    id: "banking",
    name: "Banking Exams",
    icon: "Landmark",
    description: "IBPS, SBI, RBI, RRB - Complete preparation for all banking exams",
    color: "vedanti-navy",
  },
  {
    id: "ssc",
    name: "SSC Exams",
    icon: "Shield",
    description: "CGL, CHSL, MTS - Staff Selection Commission exam coaching",
    color: "vedanti-orange",
  },
  {
    id: "railway",
    name: "Railway Exams",
    icon: "Train",
    description: "NTPC, Group D - Indian Railways recruitment exam preparation",
    color: "vedanti-navy",
  },
  {
    id: "mba",
    name: "MBA Entrance",
    icon: "GraduationCap",
    description: "MBA CET, SNAP, CMAT, MAT - Management entrance exam coaching",
    color: "vedanti-mango",
  },
  {
    id: "insurance",
    name: "Insurance Exams",
    icon: "ShieldCheck",
    description: "LIC, GIC, NIACL - Insurance sector recruitment exam preparation",
    color: "vedanti-orange",
  },
  {
    id: "others",
    name: "Other Govt Exams",
    icon: "FileText",
    description: "NABARD, IB ACIO, FCI, India Post, EPFO, ESIC & more",
    color: "vedanti-navy",
  },
];

export const courses = [
  // Banking Exams
  {
    slug: "ibps-clerk",
    name: "IBPS Clerk",
    fullName: "Institute of Banking Personnel Selection - Clerk",
    category: "banking",
    description: "IBPS Clerk is a national-level exam conducted for recruitment of clerical cadre posts in public sector banks across India. Vedanti Academy provides comprehensive coaching with shortcuts, Vedic Math techniques, and time-management strategies. The exam consists of Prelims and Mains stages, followed by provisional allotment. Our coaching covers the complete syllabus with daily practice tests and performance tracking.",
    eligibility: "Graduate in any discipline from a recognized university. Age: 20-28 years. Relaxation applicable as per government norms.",
    examPattern: {
      prelims: { sections: [{ name: "English Language", questions: 30, marks: 30, time: "20 min" }, { name: "Numerical Ability", questions: 35, marks: 35, time: "20 min" }, { name: "Reasoning Ability", questions: 35, marks: 35, time: "20 min" }], totalMarks: 100, totalTime: "60 Mins" },
      mains: { sections: [{ name: "General/Financial Awareness", questions: 50, marks: 50, time: "35 min" }, { name: "General English", questions: 40, marks: 40, time: "35 min" }, { name: "Reasoning Ability & Computer Aptitude", questions: 50, marks: 60, time: "45 min" }, { name: "Quantitative Aptitude", questions: 50, marks: 50, time: "45 min" }], totalMarks: 200, totalTime: "160 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work, Pipes & Cisterns",
        "Time, Speed & Distance (Trains, Boats & Streams)",
        "Simple & Compound Interest",
        "Averages & Mixtures (Alligation)",
        "Data Interpretation (Tables, Bar, Pie, Line Charts)",
        "Mensuration & Geometry Basics",
        "Number Series (Missing & Wrong)"
      ],
      "Reasoning Ability": [
        "Coding-Decoding (Letter, Number, Mixed)",
        "Blood Relations",
        "Direction & Distance Sense",
        "Sitting Arrangement (Linear & Circular)",
        "Syllogism (Direct & Reverse)",
        "Inequality (Coded & Direct)",
        "Puzzles (Floor-based, Box, Scheduling, Day-based)",
        "Order & Ranking",
        "Alphabet & Number Series",
        "Input-Output Machine",
        "Tabulation & Data Arrangement"
      ],
      "English Language": [
        "Reading Comprehension (Passage-based Q&A)",
        "Cloze Test (New Pattern & Old Pattern)",
        "Error Spotting (Grammar-based)",
        "Sentence Improvement & Correction",
        "Para Jumbles (Sentence Rearrangement)",
        "Fill in the Blanks (Single & Double)",
        "Vocabulary (Synonyms, Antonyms, Idioms & Phrases)",
        "Column-based Matching & Word Swap"
      ],
      "General / Financial Awareness": [
        "Current Affairs (National & International, Last 6 Months)",
        "Banking Awareness (RBI, SEBI, NABARD Policies)",
        "Financial Awareness (Repo Rate, CRR, SLR, MSF)",
        "Union Budget & Economic Survey Highlights",
        "Important Government Schemes (PM-Jan Dhan, MUDRA, etc.)",
        "Static GK (HQs, Currencies, Capitals)",
        "Awards, Appointments & Sports Events"
      ],
      "Computer Knowledge": [
        "Computer Fundamentals (Hardware, Software, Memory Types)",
        "MS Office (Word, Excel, PowerPoint Basics)",
        "Internet & Networking Basics (Protocols, Browsers)",
        "Database & Operating System Basics",
        "Computer Abbreviations & Shortcut Keys",
        "Cyber Security & Digital Banking Concepts"
      ]
    },
    batchInfo: "New batches starting every month | Weekend & Weekday batches available",
  },
  {
    slug: "ibps-po",
    name: "IBPS PO",
    fullName: "Institute of Banking Personnel Selection - Probationary Officer",
    category: "banking",
    description: "IBPS PO exam is conducted for recruitment of Probationary Officers in participating public sector banks. Our expert faculty provides in-depth preparation covering all three stages - Prelims, Mains, and Interview. The PO position is one of the most sought-after banking roles with excellent career growth, perks, and job security. Our coaching focuses on developing analytical thinking, speed, and accuracy.",
    eligibility: "Graduate in any discipline from a recognized university. Age: 20-30 years. Relaxation applicable as per government norms.",
    examPattern: {
      prelims: { sections: [{ name: "English Language", questions: 30, marks: 30, time: "20 min" }, { name: "Quantitative Aptitude", questions: 35, marks: 35, time: "20 min" }, { name: "Reasoning Ability", questions: 35, marks: 35, time: "20 min" }], totalMarks: 100, totalTime: "60 Mins" },
      mains: { sections: [{ name: "Reasoning & Computer Aptitude", questions: 45, marks: 60, time: "60 min" }, { name: "Data Analysis & Interpretation", questions: 35, marks: 60, time: "45 min" }, { name: "General Economy & Banking Awareness", questions: 40, marks: 40, time: "35 min" }, { name: "English Language", questions: 35, marks: 40, time: "40 min" }], totalMarks: 200, totalTime: "180 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work, Pipes & Cisterns",
        "Time, Speed & Distance (Trains, Boats & Streams)",
        "Simple & Compound Interest",
        "Averages & Mixtures (Alligation)",
        "Quadratic Equations",
        "Data Interpretation (Tables, Bar, Pie, Line, Radar Charts)",
        "Data Sufficiency",
        "Caselet-based DI (Advanced)",
        "Probability & Permutation-Combination"
      ],
      "Reasoning & Computer Aptitude": [
        "Coding-Decoding (All Types)",
        "Blood Relations",
        "Direction & Distance Sense",
        "Sitting Arrangement (Linear, Circular, Square)",
        "Syllogism (Direct & Reverse)",
        "Inequality (Coded & Direct)",
        "Puzzles (Floor-based, Scheduling, Comparison, Multi-variable)",
        "Order & Ranking",
        "Machine Input-Output",
        "Logical Reasoning & Critical Thinking",
        "Statement & Assumptions / Conclusions",
        "Computer Fundamentals & Networking",
        "MS Office, Database & Cyber Security Basics"
      ],
      "English Language": [
        "Reading Comprehension (Story/Economy-based, Inference)",
        "Cloze Test (New Pattern)",
        "Error Spotting & Correction",
        "Sentence Rearrangement & Para Jumbles",
        "Fill in the Blanks (Vocab-based & Grammar-based)",
        "Vocabulary (Synonyms, Antonyms, Word Usage)",
        "Descriptive Writing (Letter & Essay for Mains)",
        "Column Matching & Phrase Replacement"
      ],
      "General / Banking / Financial Awareness": [
        "Current Affairs (Last 6 Months - National & International)",
        "Banking Awareness (RBI Policy, Repo Rate, CRR, SLR, LAF)",
        "Financial Awareness (GDP, Fiscal Policy, Monetary Policy)",
        "Union Budget & Economic Survey Key Highlights",
        "Important Committees, Appointments & Rankings",
        "International Organizations (IMF, World Bank, ADB, BRICS)",
        "Important Government Schemes & Acts",
        "Static GK (HQs, Currencies, Dams, Capitals)"
      ]
    },
    batchInfo: "New batches starting every month | Upto Selection Support",
  },
  {
    slug: "sbi-clerk",
    name: "SBI Clerk",
    fullName: "State Bank of India - Junior Associate (Clerk)",
    category: "banking",
    description: "SBI Clerk exam is conducted by the State Bank of India for recruitment of Junior Associates. Get complete coaching with mock tests, study materials, and personalized mentorship at Vedanti Academy. SBI is India's largest public sector bank, and the clerk position offers excellent job security, benefits, and a stepping stone to further promotions within the banking sector.",
    eligibility: "Graduate in any discipline from a recognized university. Age: 20-28 years. Relaxation applicable as per government norms.",
    examPattern: {
      prelims: { sections: [{ name: "English Language", questions: 30, marks: 30, time: "20 min" }, { name: "Numerical Ability", questions: 35, marks: 35, time: "20 min" }, { name: "Reasoning Ability", questions: 35, marks: 35, time: "20 min" }], totalMarks: 100, totalTime: "60 Mins" },
      mains: { sections: [{ name: "General/Financial Awareness", questions: 50, marks: 50, time: "35 min" }, { name: "General English", questions: 40, marks: 40, time: "35 min" }, { name: "Quantitative Aptitude", questions: 50, marks: 50, time: "45 min" }, { name: "Reasoning Ability & Computer Aptitude", questions: 50, marks: 60, time: "45 min" }], totalMarks: 200, totalTime: "160 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude": [
        "Number System & Simplification (BODMAS)",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work, Pipes & Cisterns",
        "Time, Speed & Distance",
        "Simple & Compound Interest",
        "Averages & Mixtures (Alligation)",
        "Data Interpretation (Bar, Pie, Table, Line Charts)",
        "Mensuration Basics (Area, Volume, Perimeter)",
        "Number Series (Missing & Wrong)"
      ],
      "Reasoning Ability": [
        "Coding-Decoding",
        "Blood Relations",
        "Direction & Distance Sense",
        "Sitting Arrangement (Linear & Circular)",
        "Syllogism (Direct & Reverse)",
        "Inequality",
        "Puzzles (Floor, Box, Scheduling, Day-based)",
        "Order & Ranking",
        "Alphabet & Number Series",
        "Input-Output Machine",
        "Tabulation & Data Arrangement"
      ],
      "English Language": [
        "Reading Comprehension (Passage-based)",
        "Cloze Test",
        "Error Detection & Grammar Rules",
        "Sentence Improvement",
        "Para Jumbles",
        "Fill in the Blanks (Single & Double)",
        "Vocabulary & Idioms (Synonyms, Antonyms, Phrases)"
      ],
      "General / Financial Awareness": [
        "Current Affairs (National & International)",
        "Banking Awareness (SBI History, Products, Services)",
        "Financial Terms & Concepts (Repo, Reverse Repo, CRR)",
        "Government Schemes (PM Schemes, RBI Initiatives)",
        "Important Dates, Events & Appointments",
        "Static GK (HQs, Currencies, Capitals)"
      ],
      "Computer Knowledge": [
        "Computer Fundamentals (Hardware & Software)",
        "MS Office (Word, Excel, PowerPoint)",
        "Internet & Email Basics",
        "Computer Abbreviations & Shortcut Keys",
        "Operating System & Memory Concepts"
      ]
    },
    batchInfo: "Regular & Weekend batches | Free demo classes available",
  },
  {
    slug: "sbi-po",
    name: "SBI PO",
    fullName: "State Bank of India - Probationary Officer",
    category: "banking",
    description: "SBI PO is one of the most sought-after banking exams in India. Our structured coaching covers Prelims, Mains, and Interview preparation with focus on shortcuts and time management. As a Probationary Officer at SBI, you get excellent salary, perks, and career growth opportunities. Our coaching methodology combines traditional teaching with Vedic Math shortcuts and technology-driven learning.",
    eligibility: "Graduate in any discipline. Age: 21-30 years. Relaxation applicable as per government norms.",
    examPattern: {
      prelims: { sections: [{ name: "English Language", questions: 30, marks: 30, time: "20 min" }, { name: "Quantitative Aptitude", questions: 35, marks: 35, time: "20 min" }, { name: "Reasoning Ability", questions: 35, marks: 35, time: "20 min" }], totalMarks: 100, totalTime: "60 Mins" },
      mains: { sections: [{ name: "Data Analysis & Interpretation", questions: 35, marks: 60, time: "45 min" }, { name: "Reasoning & Computer Aptitude", questions: 45, marks: 60, time: "60 min" }, { name: "General/Economy/Banking Awareness", questions: 40, marks: 40, time: "35 min" }, { name: "English Language", questions: 35, marks: 40, time: "40 min" }], totalMarks: 200, totalTime: "180 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude & Data Analysis": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work, Pipes & Cisterns",
        "Time, Speed & Distance (Trains, Boats)",
        "Simple & Compound Interest",
        "Quadratic Equations",
        "Data Interpretation (Caselet, Tabular, Graphical, Radar)",
        "Data Sufficiency",
        "Probability & Permutation-Combination",
        "Caselet-based DI (Advanced Level)"
      ],
      "Reasoning & Computer Aptitude": [
        "Coding-Decoding & Machine Input-Output",
        "Blood Relations",
        "Direction & Distance Sense",
        "Sitting Arrangement (All Types - Linear, Circular, Square)",
        "Syllogism (Direct & Reverse)",
        "Inequality (Direct & Coded)",
        "Puzzles (Multi-level, Floor, Scheduling, Comparison)",
        "Statement & Conclusion / Assumption",
        "Critical Reasoning & Analytical Ability",
        "Computer Fundamentals & Shortcut Keys",
        "MS Office, Internet, Networking & Security Basics"
      ],
      "English Language": [
        "Reading Comprehension (Passage-based, Inference)",
        "Cloze Test & Error Spotting",
        "Sentence Rearrangement & Para Jumbles",
        "Connectors & Fill in the Blanks",
        "Vocabulary (Synonyms, Antonyms, Word Usage)",
        "Descriptive Writing (Letter Writing & Essay for Mains)",
        "Phrase Replacement & Column Matching"
      ],
      "General / Banking / Economy Awareness": [
        "Current Affairs (Last 6 Months - National & International)",
        "Banking Awareness (RBI Functions, Monetary Policy, Basel Norms)",
        "Financial & Economic Awareness (GDP, Inflation, Budget)",
        "Union Budget & Economic Survey Highlights",
        "Important Acts, Amendments & Committees",
        "International Organizations & Summits",
        "Static GK (HQs, Currencies, Dams, Rivers)"
      ]
    },
    batchInfo: "Comprehensive 6-month program | Interview preparation included",
  },
  {
    slug: "rbi-assistant",
    name: "RBI Assistant",
    fullName: "Reserve Bank of India - Assistant",
    category: "banking",
    description: "RBI Assistant exam is conducted by the Reserve Bank of India for recruitment of assistants. Our coaching provides expert guidance for both Prelims and Mains with updated study material. Working at RBI is a dream for many banking aspirants due to its prestige, excellent salary structure, and job security. Our coaching focuses on the unique aspects of RBI recruitment.",
    eligibility: "Graduate with minimum 50% marks. Age: 20-28 years. Relaxation applicable as per government norms.",
    examPattern: {
      prelims: { sections: [{ name: "English Language", questions: 30, marks: 30, time: "20 min" }, { name: "Numerical Ability", questions: 35, marks: 35, time: "20 min" }, { name: "Reasoning Ability", questions: 35, marks: 35, time: "20 min" }], totalMarks: 100, totalTime: "60 Mins" },
      mains: { sections: [{ name: "Reasoning", questions: 40, marks: 40, time: "30 min" }, { name: "English Language", questions: 40, marks: 40, time: "30 min" }, { name: "Numerical Ability", questions: 40, marks: 40, time: "30 min" }, { name: "General Awareness", questions: 40, marks: 40, time: "25 min" }, { name: "Computer Knowledge", questions: 40, marks: 40, time: "20 min" }], totalMarks: 200, totalTime: "135 Mins" },
    },
    syllabus: {
      "Numerical Ability": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work, Pipes & Cisterns",
        "Simple & Compound Interest",
        "Averages & Mixtures",
        "Data Interpretation (Bar, Pie, Line, Table Charts)",
        "Number Series (Missing & Wrong)",
        "Quadratic Equations",
        "Mensuration Basics"
      ],
      "Reasoning Ability": [
        "Coding-Decoding",
        "Blood Relations",
        "Sitting Arrangement (Linear & Circular)",
        "Syllogism",
        "Inequality (Direct & Coded)",
        "Puzzles (Floor-based, Box-based, Day-based)",
        "Direction & Distance Sense",
        "Order & Ranking",
        "Alphabet & Number Series",
        "Input-Output Machine"
      ],
      "English Language": [
        "Reading Comprehension (Passage-based Q&A)",
        "Cloze Test",
        "Error Detection & Sentence Correction",
        "Para Jumbles & Sentence Rearrangement",
        "Fill in the Blanks",
        "Vocabulary & Idioms (Synonyms, Antonyms, Phrases)"
      ],
      "General Awareness": [
        "Current Affairs (National & International)",
        "Banking & Financial Awareness (RBI Functions & Policies)",
        "Indian Economy Basics (GDP, Inflation, Policy Rates)",
        "Government Schemes & Appointments",
        "Static GK (HQs, Currencies, Capitals, Rivers)"
      ],
      "Computer Knowledge": [
        "Computer Fundamentals (Hardware & Software)",
        "MS Office (Word, Excel, PowerPoint)",
        "Internet & Networking Basics",
        "Database & OS Basics (Types, Commands)",
        "Computer Abbreviations & Shortcut Keys"
      ]
    },
    batchInfo: "Special RBI-focused batches | Mock test series included",
  },
  {
    slug: "rrb-clerk",
    name: "RRB Clerk",
    fullName: "Regional Rural Banks - Office Assistant (Clerk)",
    category: "banking",
    description: "IBPS RRB Clerk exam is conducted for recruitment in Regional Rural Banks across India. Get focused preparation with our experienced faculty and comprehensive study material. Regional Rural Banks play a crucial role in rural development and financial inclusion. Our coaching covers the unique aspects of RRB recruitment including rural banking awareness.",
    eligibility: "Graduate in any discipline. Age: 18-28 years. Relaxation applicable as per government norms.",
    examPattern: {
      prelims: { sections: [{ name: "Reasoning", questions: 40, marks: 40, time: "Cumulative" }, { name: "Numerical Ability", questions: 40, marks: 40, time: "Cumulative" }], totalMarks: 80, totalTime: "45 Mins" },
      mains: { sections: [{ name: "Reasoning", questions: 40, marks: 50, time: "Cumulative" }, { name: "Numerical Ability", questions: 40, marks: 50, time: "Cumulative" }, { name: "General Awareness", questions: 40, marks: 40, time: "Cumulative" }, { name: "English/Hindi", questions: 40, marks: 40, time: "Cumulative" }, { name: "Computer Knowledge", questions: 40, marks: 20, time: "Cumulative" }], totalMarks: 200, totalTime: "120 Mins" },
    },
    syllabus: {
      "Numerical Ability": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work",
        "Simple & Compound Interest",
        "Averages & Mixtures",
        "Data Interpretation (Bar, Pie, Table, Line)",
        "Number Series (Missing & Wrong)"
      ],
      "Reasoning Ability": [
        "Coding-Decoding",
        "Blood Relations",
        "Sitting Arrangement (Linear & Circular)",
        "Syllogism",
        "Inequality",
        "Puzzles (Floor, Box, Day-based)",
        "Direction & Distance Sense",
        "Order & Ranking"
      ],
      "English / Hindi Language": [
        "Reading Comprehension",
        "Grammar & Vocabulary",
        "Sentence Correction & Error Detection",
        "Fill in the Blanks & Cloze Test"
      ],
      "General Awareness": [
        "Current Affairs (National & International)",
        "Banking & Financial Awareness",
        "Rural Banking & Financial Inclusion",
        "Agriculture & Rural Economy",
        "Government Schemes for Rural Development"
      ],
      "Computer Knowledge": [
        "Computer Fundamentals",
        "MS Office Basics (Word, Excel)",
        "Internet Concepts & Email",
        "Computer Abbreviations"
      ]
    },
    batchInfo: "Combined RRB preparation | Online + Offline mode",
  },
  {
    slug: "rrb-po",
    name: "RRB PO",
    fullName: "Regional Rural Banks - Officer Scale I",
    category: "banking",
    description: "IBPS RRB PO exam is conducted for Officer Scale I positions in Regional Rural Banks. Our coaching covers complete syllabus with focus on rural banking awareness. As an Officer in RRBs, you'll play a vital role in India's rural financial inclusion mission with competitive salary and benefits.",
    eligibility: "Graduate in any discipline. Age: 18-30 years. Relaxation applicable as per government norms.",
    examPattern: {
      prelims: { sections: [{ name: "Reasoning", questions: 40, marks: 40, time: "Cumulative" }, { name: "Quantitative Aptitude", questions: 40, marks: 40, time: "Cumulative" }], totalMarks: 80, totalTime: "45 Mins" },
      mains: { sections: [{ name: "Reasoning", questions: 40, marks: 50, time: "Cumulative" }, { name: "Quantitative Aptitude", questions: 40, marks: 50, time: "Cumulative" }, { name: "General Awareness", questions: 40, marks: 40, time: "Cumulative" }, { name: "English/Hindi", questions: 40, marks: 40, time: "Cumulative" }, { name: "Computer Knowledge", questions: 40, marks: 20, time: "Cumulative" }], totalMarks: 200, totalTime: "120 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work, Pipes & Cisterns",
        "Simple & Compound Interest",
        "Data Interpretation (Tables, Charts, Graphs)",
        "Quadratic Equations",
        "Number Series (Missing & Wrong)"
      ],
      "Reasoning Ability": [
        "Coding-Decoding",
        "Blood Relations",
        "Sitting Arrangement (Linear & Circular)",
        "Syllogism",
        "Inequality",
        "Puzzles (Floor-based, Scheduling, Comparison)",
        "Machine Input-Output",
        "Statement & Conclusion"
      ],
      "English / Hindi Language": [
        "Reading Comprehension",
        "Grammar & Sentence Correction",
        "Vocabulary & Idioms",
        "Error Detection & Para Jumbles"
      ],
      "General Awareness": [
        "Current Affairs (National & International)",
        "Banking Awareness & Financial Terms",
        "Rural Banking & Agriculture",
        "Financial Inclusion Initiatives (PM-Jan Dhan, MUDRA)",
        "Government Schemes & Appointments"
      ],
      "Computer Knowledge": [
        "Computer Fundamentals",
        "MS Office (Word, Excel, PowerPoint)",
        "Internet & Networking Basics",
        "Computer Abbreviations & Shortcut Keys"
      ]
    },
    batchInfo: "Combined banking preparation with RRB specialization",
  },
  // SSC Exams
  {
    slug: "ssc-mts",
    name: "SSC MTS",
    fullName: "Staff Selection Commission - Multi Tasking Staff",
    category: "ssc",
    description: "SSC MTS exam is for recruitment of Multi Tasking Staff in various central government departments. Ideal for 10th pass candidates looking for government jobs. The MTS position offers a secure government career with all central government benefits including pension, medical, and housing allowance.",
    eligibility: "10th Pass (Matriculation) from a recognized board. Age: 18-25 years. Relaxation applicable as per government norms.",
    examPattern: {
      tier1: { sections: [{ name: "Numerical & Mathematical Ability", questions: 20, marks: 60, time: "Cumulative" }, { name: "Reasoning Ability & Problem Solving", questions: 20, marks: 60, time: "Cumulative" }, { name: "General Awareness", questions: 25, marks: 75, time: "Cumulative" }, { name: "English Language & Comprehension", questions: 25, marks: 75, time: "Cumulative" }], totalMarks: 270, totalTime: "90 Mins" },
    },
    syllabus: {
      "Numerical & Mathematical Ability": [
        "Number System (LCM, HCF, Factors)",
        "Percentage & Profit / Loss",
        "Ratio & Proportion",
        "Time & Work",
        "Time, Speed & Distance",
        "Simple & Compound Interest",
        "Averages",
        "Algebra Basics (Linear Equations)",
        "Geometry & Mensuration Basics",
        "Data Interpretation (Basic Tables & Charts)"
      ],
      "Reasoning Ability & Problem Solving": [
        "Analogy (Word, Number, Letter)",
        "Classification (Odd One Out)",
        "Coding-Decoding",
        "Series (Number, Letter, Figure)",
        "Direction & Distance Sense",
        "Blood Relations",
        "Venn Diagrams",
        "Non-Verbal Reasoning (Mirror/Water Image, Paper Folding)",
        "Calendar & Clock Problems",
        "Embedded Figures & Pattern Completion"
      ],
      "General Awareness": [
        "History (Ancient, Medieval & Modern India)",
        "Geography (India & World - Physical, Climate, Rivers)",
        "Indian Polity (Constitution, Parliament, Judiciary)",
        "Economics Basics (Indian Economy, Five Year Plans)",
        "Science (Physics, Chemistry, Biology Fundamentals)",
        "Current Affairs (Last 6 Months - National & International)",
        "Important Dates, Events & Awards"
      ],
      "English Language & Comprehension": [
        "Reading Comprehension (Short Passages)",
        "Spot the Error (Grammar Rules)",
        "Fill in the Blanks (Vocabulary & Grammar)",
        "Sentence Completion & Improvement",
        "Synonyms & Antonyms",
        "Spelling Correction",
        "One Word Substitution",
        "Idioms & Phrases"
      ]
    },
    batchInfo: "Special batches for SSC MTS | 3-month intensive program",
  },
  {
    slug: "ssc-chsl",
    name: "SSC CHSL",
    fullName: "Staff Selection Commission - Combined Higher Secondary Level",
    category: "ssc",
    description: "SSC CHSL exam is conducted for recruitment of LDC, JSA, PA/SA, DEO posts in central government offices. Our coaching focuses on speed and accuracy techniques. This is one of the most popular government exams for 12th pass candidates, offering positions in various ministries, departments, and organizations of the Government of India.",
    eligibility: "12th Pass (Higher Secondary) from a recognized board. Age: 18-27 years. Relaxation applicable as per government norms.",
    examPattern: {
      tier1: { sections: [{ name: "General Intelligence", questions: 25, marks: 50, time: "Cumulative" }, { name: "English Language", questions: 25, marks: 50, time: "Cumulative" }, { name: "Quantitative Aptitude", questions: 25, marks: 50, time: "Cumulative" }, { name: "General Awareness", questions: 25, marks: 50, time: "Cumulative" }], totalMarks: 200, totalTime: "60 Mins" },
      tier2: { sections: [{ name: "Mathematical Abilities", questions: 30, marks: 90, time: "Cumulative" }, { name: "Reasoning & General Intelligence", questions: 30, marks: 90, time: "Cumulative" }, { name: "English Language & Comprehension", questions: 40, marks: 120, time: "Cumulative" }, { name: "General Awareness", questions: 20, marks: 60, time: "Cumulative" }, { name: "Computer Knowledge", questions: 15, marks: 45, time: "Cumulative" }], totalMarks: 405, totalTime: "135 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude / Mathematical Abilities": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work, Pipes & Cisterns",
        "Simple & Compound Interest",
        "Averages & Mixtures (Alligation)",
        "Algebra (Linear & Quadratic Equations)",
        "Geometry (Triangles, Circles, Quadrilaterals)",
        "Trigonometry (Heights & Distances, Identities)",
        "Mensuration (2D & 3D - Area, Volume, Perimeter)",
        "Data Interpretation (Bar, Pie, Line, Table)"
      ],
      "General Intelligence & Reasoning": [
        "Analogy & Classification (Word, Number, Figure)",
        "Coding-Decoding",
        "Series (Number, Letter, Figure)",
        "Sitting Arrangement & Puzzles",
        "Syllogism & Logical Sequence",
        "Blood Relations",
        "Direction & Distance Sense",
        "Venn Diagrams",
        "Non-Verbal Reasoning (Mirror/Water Image, Paper Folding/Cutting)",
        "Statement & Conclusion"
      ],
      "English Language & Comprehension": [
        "Reading Comprehension (Passage-based Q&A)",
        "Error Detection & Correction (Grammar-based)",
        "Fill in the Blanks (Vocabulary & Grammar)",
        "Synonyms & Antonyms",
        "One Word Substitution",
        "Idioms & Phrases",
        "Sentence Improvement & Rearrangement",
        "Active/Passive Voice & Direct/Indirect Speech",
        "Cloze Test & Para Jumbles"
      ],
      "General Awareness": [
        "History (Ancient, Medieval, Modern India, Freedom Movement)",
        "Geography (India & World - Physical, Climate, Resources)",
        "Indian Polity (Constitution, Governance, Parliament)",
        "Economics (Micro, Macro, Indian Economy)",
        "Science & Technology (Physics, Chemistry, Biology)",
        "Current Affairs (Last 6 Months) & Static GK"
      ],
      "Computer Knowledge": [
        "Computer Fundamentals (Hardware, Software, Memory)",
        "MS Office (Word, Excel, PowerPoint) & Shortcut Keys",
        "Internet & Networking Basics (Protocols, Email)",
        "Operating System Basics (Windows, Linux)",
        "Computer Abbreviations & Terminology"
      ]
    },
    batchInfo: "Comprehensive CHSL preparation | Typing practice included",
  },
  {
    slug: "ssc-cgl",
    name: "SSC CGL",
    fullName: "Staff Selection Commission - Combined Graduate Level",
    category: "ssc",
    description: "SSC CGL 2026 has been notified for 12,256 vacancies across central government ministries and departments — Income Tax Inspector, Assistant Audit Officer (AAO), Junior Statistical Officer (JSO), Sub-Inspector, Auditor, Assistant, Tax Assistant and more. The exam is conducted in two tiers — Tier 1 is qualifying in nature while Tier 2 is scoring and decides final selection. Vedanti Academy's SSC CGL programme delivers complete Tier 1 + Tier 2 (Paper 1, 2 & 3) coverage with Vedic-Math shortcuts, sectional timing practice, daily quizzes and full-length mocks.",
    eligibility: "Graduate from a recognized university. Age: 18-32 years (varies by post — JSO 18-32, AAO 18-30, others 18-32). Relaxation: OBC +3 yrs, SC/ST +5 yrs, PwD +10 yrs, Ex-Servicemen as per official notification.",
    examPattern: {
      tier1: {
        nature: "Qualifying — marks NOT counted in final selection",
        mode: "Online (Computer-based)",
        sectionalTiming: "Yes — 15 minutes per section (new for 2026)",
        negativeMarking: "0.50 marks deducted per wrong answer",
        sections: [
          { name: "General Intelligence & Reasoning", questions: 25, marks: 50, time: "15 min" },
          { name: "General Awareness", questions: 25, marks: 50, time: "15 min" },
          { name: "Quantitative Aptitude", questions: 25, marks: 50, time: "15 min" },
          { name: "English Comprehension", questions: 25, marks: 50, time: "15 min" },
        ],
        totalQuestions: 100,
        totalMarks: 200,
        totalTime: "60 Mins",
      },
      tier2Paper1: {
        nature: "Scoring & Compulsory for ALL posts — final selection based on this",
        mode: "Online (Computer-based)",
        sectionalTiming: "Yes — module-wise timing (new for 2026)",
        negativeMarking: "1 mark for Section I, Section II & Module-I of Section III; 0.50 marks for Paper II",
        sections: [
          { name: "Section I · Module I: Mathematical Abilities", questions: 30, marks: 90, time: "30 min", weightage: "23%" },
          { name: "Section I · Module II: Reasoning & General Intelligence", questions: 30, marks: 90, time: "30 min", weightage: "23%" },
          { name: "Section II · Module I: English Language & Comprehension", questions: 45, marks: 135, time: "40 min", weightage: "35%" },
          { name: "Section II · Module II: General Awareness", questions: 25, marks: 75, time: "20 min", weightage: "19%" },
          { name: "Section III · Module I: Computer Knowledge Test", questions: 20, marks: 60, time: "15 min", weightage: "Qualifying" },
          { name: "Section III · Module II: Data Entry Speed Test (Session II)", questions: "1 task", marks: "Qualifying", time: "15 min", weightage: "Qualifying" },
        ],
        totalQuestions: 150,
        totalMarks: 450,
        totalTime: "2 hr 30 min (Session I) + 15 min (Session II DEST)",
      },
      tier2Paper2: {
        nature: "For Junior Statistical Officer (JSO) post only",
        subject: "Statistics",
        questions: 100,
        marks: 200,
        time: "2 hours",
        negativeMarking: "0.50 marks per wrong answer",
      },
      tier2Paper3: {
        nature: "For Assistant Audit Officer / Assistant Accounts Officer (AAO) post only",
        subject: "General Studies (Finance & Economics)",
        questions: 100,
        marks: 200,
        time: "2 hours",
        negativeMarking: "0.50 marks per wrong answer",
      },
    },
    selectionProcess: "Tier 1 (qualifying) → Tier 2 Paper 1 + Paper 2 (JSO only) / Paper 3 (AAO only) — final merit based on Tier 2 marks. Document verification follows.",
    vacancies: "12,256 (SSC CGL 2026 Notification)",
    importantPosts: ["Assistant Audit Officer (AAO)", "Assistant Accounts Officer", "Inspector — Income Tax", "Inspector — Central Excise / GST", "Sub-Inspector (CBI / NIA)", "Junior Statistical Officer (JSO)", "Assistant Section Officer (ASO)", "Auditor", "Accountant", "Tax Assistant", "Upper Division Clerk"],
    syllabus: {
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work, Pipes & Cisterns",
        "Time, Speed & Distance (Trains, Boats & Streams)",
        "Simple & Compound Interest",
        "Algebra (Linear Equations, Quadratic Equations)",
        "Geometry (Triangles, Circles, Quadrilaterals, Polygons)",
        "Coordinate Geometry (Distance, Section Formula)",
        "Trigonometry (Identities, Heights & Distances)",
        "Mensuration (2D & 3D - Area, Volume, Surface Area)",
        "Statistics (Mean, Median, Mode, Standard Deviation)",
        "Data Interpretation (Bar, Pie, Line, Table, Mixed)"
      ],
      "General Intelligence & Reasoning": [
        "Analogy & Classification (Word, Number, Figure)",
        "Coding-Decoding",
        "Series (Number, Letter, Figure)",
        "Matrix-based Reasoning",
        "Blood Relations",
        "Direction & Distance Sense",
        "Syllogism & Logical Venn Diagrams",
        "Non-Verbal Reasoning (Mirror/Water Image, Paper Folding/Cutting)",
        "Embedded Figures & Pattern Completion",
        "Statement & Conclusion / Assumption",
        "Mathematical Operations & Word Building"
      ],
      "English Language & Comprehension": [
        "Reading Comprehension (Passage-based Q&A, Inference)",
        "Error Detection & Correction",
        "Fill in the Blanks (Grammar & Vocabulary)",
        "Synonyms & Antonyms",
        "One Word Substitution",
        "Idioms & Phrases",
        "Sentence Improvement & Rearrangement",
        "Cloze Test & Para Jumbles",
        "Active/Passive Voice & Direct/Indirect Speech",
        "Spelling & Vocabulary-based Questions"
      ],
      "General Awareness": [
        "History (Ancient, Medieval, Modern India, Freedom Movement)",
        "Geography (India & World - Physical, Climate, Agriculture, Resources)",
        "Indian Polity (Constitution, Parliament, Judiciary, Governance)",
        "Economics (Micro, Macro, Indian Economy, Budgeting)",
        "Science & Technology (Physics, Chemistry, Biology, Space)",
        "Current Affairs (Last 6-12 Months) & Static GK",
        "Awards, Honours, Sports & Important Summits"
      ],
      "Computer Knowledge": [
        "Computer Fundamentals (Hardware, Software, Memory, I/O)",
        "MS Office (Word, Excel, PowerPoint) & Shortcut Keys",
        "Database Management Basics (DBMS Concepts)",
        "Internet, Email & Cyber Security Basics",
        "Networking Fundamentals (LAN, WAN, Protocols)",
        "Operating Systems (Windows, Linux Basics)"
      ]
    },
    batchInfo: "6-month intensive program | Weekly mock tests | Sectional timing practice",
  },
  // Railway Exams
  {
    slug: "railway-ntpc",
    name: "Railway NTPC",
    fullName: "Railway Recruitment Board - Non-Technical Popular Categories",
    category: "railway",
    description: "RRB NTPC exam is conducted for various non-technical positions in Indian Railways including Station Master, Goods Guard, Commercial Apprentice, Clerk, and more. Our coaching provides comprehensive preparation with railway-specific GK and current affairs. Indian Railways is the largest employer in India, offering excellent job security, perks, and career growth.",
    eligibility: "Graduate in any discipline from a recognized university. Age: 18-33 years. Relaxation applicable as per government norms.",
    examPattern: {
      cbt1: { sections: [{ name: "Mathematics", questions: 30, marks: 30, time: "Cumulative" }, { name: "General Intelligence & Reasoning", questions: 30, marks: 30, time: "Cumulative" }, { name: "General Awareness", questions: 40, marks: 40, time: "Cumulative" }], totalMarks: 100, totalTime: "90 Mins" },
      cbt2: { sections: [{ name: "Mathematics", questions: 35, marks: 35, time: "Cumulative" }, { name: "General Intelligence & Reasoning", questions: 35, marks: 35, time: "Cumulative" }, { name: "General Awareness", questions: 50, marks: 50, time: "Cumulative" }], totalMarks: 120, totalTime: "90 Mins" },
    },
    syllabus: {
      "Mathematics": [
        "Number System & Simplification (BODMAS, LCM, HCF)",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work, Pipes & Cisterns",
        "Time, Speed & Distance (Trains, Boats & Streams)",
        "Simple & Compound Interest",
        "Averages & Mixtures",
        "Algebra Basics (Linear & Quadratic Equations)",
        "Geometry & Mensuration (2D & 3D)",
        "Trigonometry (Basic Identities, Heights & Distances)",
        "Data Interpretation (Tables, Charts)"
      ],
      "General Intelligence & Reasoning": [
        "Analogy & Classification",
        "Coding-Decoding",
        "Series (Number, Letter, Figure)",
        "Syllogism & Logical Sequence",
        "Blood Relations",
        "Direction & Distance Sense",
        "Venn Diagrams",
        "Statement & Conclusion / Assumption",
        "Non-Verbal Reasoning (Mirror/Water Image, Paper Folding)",
        "Mathematical Operations & Clock/Calendar"
      ],
      "General Awareness": [
        "History of India & World (Ancient, Medieval, Modern)",
        "Indian & World Geography (Physical, Climate, Resources)",
        "Indian Polity & Constitution (Parliament, Judiciary)",
        "Indian Economy (Budgeting, Policies, Banking)",
        "Science & Technology (Physics, Chemistry, Biology)",
        "Current Affairs (Last 12 Months - National & International)",
        "Indian Railways General Knowledge (History, Zones, Trains)",
        "Important Dates, Events, Awards & Honours",
        "Books, Authors, Sports & Games"
      ]
    },
    batchInfo: "Railway-focused batches | Combined SSC+Railway preparation available",
  },
  {
    slug: "railway-group-d",
    name: "Railway Group D",
    fullName: "Railway Recruitment Board - Group D (Level 1)",
    category: "railway",
    description: "RRB Group D exam is for recruitment to various Group D posts in Indian Railways including Track Maintainer, Helper, Porter, and more. Our coaching provides focused preparation with emphasis on speed and accuracy. This is an excellent opportunity for 10th pass candidates to secure a government job with Indian Railways.",
    eligibility: "10th Pass + ITI or equivalent. Age: 18-33 years. Relaxation applicable as per government norms.",
    examPattern: {
      cbt: { sections: [{ name: "Mathematics", questions: 25, marks: 25, time: "Cumulative" }, { name: "General Intelligence & Reasoning", questions: 30, marks: 30, time: "Cumulative" }, { name: "General Science", questions: 25, marks: 25, time: "Cumulative" }, { name: "General Awareness & Current Affairs", questions: 20, marks: 20, time: "Cumulative" }], totalMarks: 100, totalTime: "90 Mins" },
    },
    syllabus: {
      "Mathematics": [
        "Number System (LCM, HCF, BODMAS)",
        "Decimals & Fractions",
        "Percentage & Profit / Loss",
        "Ratio & Proportion",
        "Time & Work",
        "Time, Speed & Distance",
        "Simple & Compound Interest",
        "Mensuration (Area, Volume, Perimeter)",
        "Algebra Basics (Linear Equations)",
        "Geometry (Triangles, Circles, Angles)",
        "Data Interpretation (Basic Tables & Charts)"
      ],
      "General Intelligence & Reasoning": [
        "Analogy (Word, Number, Letter)",
        "Classification (Odd One Out)",
        "Coding-Decoding",
        "Mathematical Operations",
        "Series (Number, Letter, Figure)",
        "Syllogism",
        "Venn Diagrams",
        "Blood Relations",
        "Direction & Distance Sense",
        "Mirror & Water Image",
        "Calendar & Clock Problems"
      ],
      "General Science": [
        "Physics (Units, Motion, Force, Work & Energy, Light, Sound, Electricity)",
        "Chemistry (Elements, Acids & Bases, Chemical Reactions, Metals & Non-metals)",
        "Biology (Human Body Systems, Diseases, Nutrition, Cell Structure)",
        "Environmental Science (Pollution, Conservation, Ecosystem)"
      ],
      "General Awareness & Current Affairs": [
        "Indian History (Ancient, Medieval, Modern, Freedom Movement)",
        "Indian Geography (Rivers, Mountains, Climate, Agriculture)",
        "Indian Polity (Constitution, Governance)",
        "Current Affairs (Last 6-12 Months)",
        "Sports, Important Days & Events",
        "Indian Railways GK (Zones, History, Key Projects)"
      ]
    },
    batchInfo: "3-month crash course | Physical fitness guidance included",
  },
  // MBA Entrance
  {
    slug: "mah-mba-cet",
    name: "MAH MBA CET",
    fullName: "Maharashtra Common Entrance Test for MBA/MMS",
    category: "mba",
    description: "MAH MBA CET is the state-level entrance exam for MBA/MMS admissions in Maharashtra's top colleges including JBIMS, Sydenham, Welingkar, PUMBA, and more. Our coaching uses proven shortcuts and strategies to crack this exam with ease. With our 99 percentile achievers, Vedanti Academy has established itself as a leading MBA CET coaching institute in the region.",
    eligibility: "Graduate with minimum 50% marks. Final year students can also apply. No upper age limit.",
    examPattern: {
      exam: { sections: [{ name: "Logical Reasoning", questions: 75, marks: 75, time: "Cumulative" }, { name: "Abstract Reasoning", questions: 25, marks: 25, time: "Cumulative" }, { name: "Quantitative Aptitude", questions: 50, marks: 50, time: "Cumulative" }, { name: "Verbal Ability / Reading Comprehension", questions: 50, marks: 50, time: "Cumulative" }], totalMarks: 200, totalTime: "150 Mins" },
    },
    syllabus: {
      "Logical Reasoning": [
        "Linear & Circular Arrangement",
        "Blood Relations",
        "Direction & Distance Sense",
        "Coding-Decoding (All Types)",
        "Syllogism (Categorical & Conditional)",
        "Inequality (Direct & Coded)",
        "Puzzles (Floor, Scheduling, Comparison, Age-based)",
        "Logical Sequence & Series",
        "Statements & Assumptions / Conclusions",
        "Cause & Effect Analysis",
        "Input-Output Machine"
      ],
      "Abstract Reasoning": [
        "Pattern Recognition & Completion",
        "Figure Series (Next in Sequence)",
        "Mirror & Water Image",
        "Paper Folding & Cutting",
        "Embedded Figures & Visual Analogy",
        "Classification & Grouping (Visual)"
      ],
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work, Pipes & Cisterns",
        "Time, Speed & Distance",
        "Simple & Compound Interest",
        "Averages & Mixtures (Alligation)",
        "Data Interpretation (Tables, Graphs, Charts, Caselets)",
        "Algebra (Linear & Quadratic Equations)",
        "Geometry & Mensuration (Area, Volume)"
      ],
      "Verbal Ability & Reading Comprehension": [
        "Reading Comprehension (Long & Short Passages, Inference)",
        "Vocabulary (Synonyms, Antonyms, Analogies, Contextual Usage)",
        "Grammar (Error Detection, Sentence Correction, Tenses)",
        "Para Jumbles & Sentence Rearrangement",
        "Fill in the Blanks (Grammar & Vocabulary)",
        "Critical Reasoning Passages (Strengthen/Weaken/Infer)",
        "Verbal Logic & Para Completion"
      ]
    },
    batchInfo: "Specialized CET batches | Previous year paper analysis",
  },
  {
    slug: "snap",
    name: "SNAP",
    fullName: "Symbiosis National Aptitude Test",
    category: "mba",
    description: "SNAP is the entrance exam for MBA programs at Symbiosis International University campuses including SIBM Pune, SCMHRD, SIIB, and more. Our focused coaching helps students master the unique SNAP pattern with its emphasis on speed and quick decision-making.",
    eligibility: "Graduate with minimum 50% marks from a recognized university. No upper age limit.",
    examPattern: {
      exam: { sections: [{ name: "General English (RC, Verbal Reasoning, Verbal Ability)", questions: 15, marks: 15, time: "Cumulative" }, { name: "Analytical & Logical Reasoning", questions: 25, marks: 25, time: "Cumulative" }, { name: "Quantitative, DI & Data Sufficiency", questions: 20, marks: 20, time: "Cumulative" }], totalMarks: 60, totalTime: "60 Mins" },
    },
    syllabus: {
      "General English": [
        "Reading Comprehension (Short & Long Passages)",
        "Vocabulary (Synonyms, Antonyms, Analogies, Contextual Usage)",
        "Grammar & Sentence Correction (Error Detection)",
        "Verbal Reasoning (Inference, Strengthen/Weaken)",
        "Para Jumbles & Sentence Completion",
        "Fill in the Blanks"
      ],
      "Analytical & Logical Reasoning": [
        "Analytical Reasoning (Arrangements, Grouping, Selections)",
        "Logical Reasoning (Syllogism, Statements & Assumptions)",
        "Series & Patterns (Number, Letter, Figure)",
        "Blood Relations & Direction Sense",
        "Coding-Decoding",
        "Critical Reasoning (Cause & Effect, Strong/Weak Arguments)",
        "Visual Reasoning & Non-Verbal Patterns"
      ],
      "Quantitative Aptitude, DI & Data Sufficiency": [
        "Number System & Simplification",
        "Arithmetic (Percentage, Ratio, Profit & Loss, SI/CI)",
        "Algebra (Linear & Quadratic Equations)",
        "Geometry & Mensuration",
        "Data Interpretation (Tables, Charts, Graphs, Caselets)",
        "Data Sufficiency (Two-Statement Problems)"
      ]
    },
    batchInfo: "Combined MBA entrance preparation | Includes SNAP, CET, CMAT",
  },
  {
    slug: "cmat",
    name: "CMAT",
    fullName: "Common Management Admission Test",
    category: "mba",
    description: "CMAT is a national-level entrance exam conducted by NTA for admission to MBA/PGDM programs across India. Our coaching provides comprehensive preparation covering all five sections including the unique Innovation & Entrepreneurship section.",
    eligibility: "Graduate in any discipline from a recognized university. No upper age limit.",
    examPattern: {
      exam: { sections: [{ name: "Quantitative Techniques & Data Interpretation", questions: 25, marks: 100, time: "Cumulative" }, { name: "Logical Reasoning", questions: 25, marks: 100, time: "Cumulative" }, { name: "Language Comprehension", questions: 25, marks: 100, time: "Cumulative" }, { name: "General Awareness", questions: 25, marks: 100, time: "Cumulative" }, { name: "Innovation & Entrepreneurship", questions: 25, marks: 100, time: "Cumulative" }], totalMarks: 500, totalTime: "180 Mins" },
    },
    syllabus: {
      "Quantitative Techniques & Data Interpretation": [
        "Number System & Simplification",
        "Algebra (Equations, Progressions, Inequalities)",
        "Arithmetic (Percentage, Ratio, Profit & Loss, SI, CI)",
        "Time & Work, Pipes & Cisterns",
        "Time, Speed & Distance",
        "Geometry & Mensuration (2D & 3D)",
        "Data Interpretation (Tables, Charts, Caselets)",
        "Permutation, Combination & Probability"
      ],
      "Logical Reasoning": [
        "Coding-Decoding & Series (Number, Letter, Figure)",
        "Blood Relations & Direction Sense",
        "Syllogism & Logical Venn Diagrams",
        "Sitting Arrangement (Linear & Circular)",
        "Puzzles (Floor, Scheduling, Comparison)",
        "Statement & Assumptions / Conclusions",
        "Critical Reasoning (Strengthen/Weaken/Infer)"
      ],
      "Language Comprehension": [
        "Reading Comprehension (Long & Short Passages)",
        "Grammar (Error Detection, Sentence Correction)",
        "Vocabulary (Synonyms, Antonyms, Analogies)",
        "Para Jumbles & Sentence Completion",
        "Fill in the Blanks & Cloze Test",
        "Verbal Ability & Verbal Logic"
      ],
      "General Awareness": [
        "Current Affairs (National & International, Last 12 Months)",
        "Business & Economy (Markets, Industries, Policies)",
        "Science & Technology (Inventions, Space, IT)",
        "Awards, Events & Important Summits",
        "Static GK (Geography, History, Polity Basics)"
      ],
      "Innovation & Entrepreneurship": [
        "Innovation Concepts (Design Thinking, Creativity)",
        "Entrepreneurship Fundamentals (Lean Startup, MVP)",
        "Start-up Ecosystem in India (Unicorns, Funding Stages)",
        "Business Models & Revenue Strategies",
        "Case Studies on Indian & Global Startups",
        "Government Initiatives (Startup India, Make in India)"
      ]
    },
    batchInfo: "All-in-one MBA entrance coaching | Mock test series",
  },
  {
    slug: "mat",
    name: "MAT",
    fullName: "Management Aptitude Test",
    category: "mba",
    description: "MAT is conducted by AIMA for admission to MBA programs in over 600 B-Schools across India. Our coaching covers all five sections with proven strategies and practice tests. MAT scores are accepted by a wide network of management institutes.",
    eligibility: "Graduate in any discipline from a recognized university. No upper age limit.",
    examPattern: {
      exam: { sections: [{ name: "Language Comprehension", questions: 40, marks: 40, time: "30 min" }, { name: "Mathematical Skills", questions: 40, marks: 40, time: "40 min" }, { name: "Data Analysis & Sufficiency", questions: 40, marks: 40, time: "35 min" }, { name: "Intelligence & Critical Reasoning", questions: 40, marks: 40, time: "30 min" }, { name: "Indian & Global Environment", questions: 40, marks: 40, time: "15 min" }], totalMarks: 200, totalTime: "150 Mins" },
    },
    syllabus: {
      "Language Comprehension": [
        "Reading Comprehension (Short & Long Passages)",
        "Vocabulary (Synonyms, Antonyms, Analogies)",
        "Grammar (Error Detection, Sentence Correction)",
        "Para Jumbles & Sentence Rearrangement",
        "Fill in the Blanks",
        "Verbal Analogies & Contextual Word Usage"
      ],
      "Mathematical Skills": [
        "Number System & Simplification",
        "Algebra (Equations, Progressions)",
        "Arithmetic (Percentage, Ratio, Profit & Loss, SI/CI)",
        "Geometry & Mensuration (2D & 3D)",
        "Trigonometry Basics",
        "Data Interpretation (Tables, Charts)"
      ],
      "Data Analysis & Sufficiency": [
        "Data Sufficiency (Two-Statement Problems)",
        "Data Analysis (Tables, Charts, Graphs)",
        "Caselet-based DI",
        "Comparison-based Problems",
        "Logical Data Analysis"
      ],
      "Intelligence & Critical Reasoning": [
        "Analytical Reasoning (Arrangements, Grouping)",
        "Critical Reasoning (Strengthen/Weaken/Infer)",
        "Series & Patterns (Number, Letter, Figure)",
        "Coding-Decoding & Blood Relations",
        "Sitting Arrangements",
        "Logical Connectives & Statement Analysis"
      ],
      "Indian & Global Environment": [
        "Current Affairs (National & International)",
        "Business & Economy (Markets, Policies, Budget)",
        "International Affairs & Organizations",
        "Science & Technology Developments",
        "Indian Economy, History & Polity"
      ]
    },
    batchInfo: "Combined MBA entrance program | 4 attempts per year",
  },
  // Insurance Exams
  {
    slug: "lic-assistant",
    name: "LIC Assistant",
    fullName: "Life Insurance Corporation of India - Assistant",
    category: "insurance",
    description: "LIC Assistant exam is conducted for recruitment of assistants in LIC branches across India. Get comprehensive coaching with insurance-sector specific preparation. LIC is India's largest life insurer with excellent salary, job security, and benefits for its employees.",
    eligibility: "Graduate from a recognized university. Age: 20-30 years. Relaxation applicable as per government norms.",
    examPattern: {
      prelims: { sections: [{ name: "English Language", questions: 30, marks: 30, time: "20 min" }, { name: "Numerical Ability", questions: 35, marks: 35, time: "20 min" }, { name: "Reasoning Ability", questions: 35, marks: 35, time: "20 min" }], totalMarks: 100, totalTime: "60 Mins" },
      mains: { sections: [{ name: "General/Financial Awareness", questions: 50, marks: 50, time: "35 min" }, { name: "General English", questions: 40, marks: 40, time: "35 min" }, { name: "Quantitative Aptitude", questions: 50, marks: 50, time: "45 min" }, { name: "Reasoning Ability & Computer Aptitude", questions: 50, marks: 60, time: "45 min" }], totalMarks: 200, totalTime: "160 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work, Pipes & Cisterns",
        "Simple & Compound Interest",
        "Averages & Mixtures",
        "Data Interpretation (Bar, Pie, Table, Line)",
        "Number Series (Missing & Wrong)"
      ],
      "Reasoning Ability": [
        "Coding-Decoding",
        "Blood Relations",
        "Sitting Arrangement (Linear & Circular)",
        "Syllogism",
        "Inequality (Direct & Coded)",
        "Puzzles (Floor, Box, Scheduling)",
        "Direction & Distance Sense",
        "Order & Ranking",
        "Input-Output Machine"
      ],
      "English Language": [
        "Reading Comprehension",
        "Cloze Test",
        "Error Detection & Sentence Improvement",
        "Fill in the Blanks",
        "Vocabulary (Synonyms, Antonyms, Idioms)"
      ],
      "General / Financial Awareness": [
        "Current Affairs (National & International)",
        "Insurance Awareness (LIC Products, IRDAI Policies, Regulations)",
        "Banking & Financial Awareness (RBI, SEBI)",
        "Government Schemes (PM Insurance Schemes, PMJJBY, PMSBY)",
        "Static GK & Important Appointments"
      ],
      "Computer Knowledge": [
        "Computer Fundamentals (Hardware & Software)",
        "MS Office (Word, Excel, PowerPoint)",
        "Internet & Email Basics",
        "Computer Abbreviations & Shortcut Keys"
      ]
    },
    batchInfo: "Insurance sector focused batches",
  },
  {
    slug: "lic-aao",
    name: "LIC AAO",
    fullName: "Life Insurance Corporation - Assistant Administrative Officer",
    category: "insurance",
    description: "LIC AAO is a prestigious exam for officer-level positions in LIC. Our coaching covers all phases including Prelims, Mains, and Interview preparation. As an AAO, you get excellent career growth opportunities, managerial responsibilities, and attractive salary packages.",
    eligibility: "Graduate with minimum 60% marks. Age: 21-30 years. Relaxation applicable as per government norms.",
    examPattern: {
      prelims: { sections: [{ name: "Reasoning Ability", questions: 35, marks: 35, time: "20 min" }, { name: "Quantitative Aptitude", questions: 35, marks: 35, time: "20 min" }, { name: "English Language", questions: 30, marks: 30, time: "20 min" }], totalMarks: 100, totalTime: "60 Mins" },
      mains: { sections: [{ name: "Reasoning & Computer Aptitude", questions: 45, marks: 60, time: "60 min" }, { name: "Data Analysis & Interpretation", questions: 35, marks: 60, time: "45 min" }, { name: "General Knowledge & Current Affairs", questions: 40, marks: 40, time: "35 min" }, { name: "Insurance & Financial Market Awareness", questions: 30, marks: 40, time: "20 min" }], totalMarks: 200, totalTime: "160 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude & Data Analysis": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work",
        "Simple & Compound Interest",
        "Data Interpretation (Tables, Graphs, Charts, Caselets)",
        "Data Sufficiency",
        "Quadratic Equations & Number Series"
      ],
      "Reasoning & Computer Aptitude": [
        "Coding-Decoding",
        "Sitting Arrangement (Linear, Circular, Square)",
        "Syllogism (Direct & Reverse)",
        "Inequality (Coded & Direct)",
        "Puzzles (Floor, Scheduling, Multi-variable)",
        "Blood Relations & Direction Sense",
        "Critical Reasoning & Machine Input-Output",
        "Computer Fundamentals, MS Office & Networking"
      ],
      "English Language": [
        "Reading Comprehension (Passage-based, Inference)",
        "Error Spotting & Sentence Correction",
        "Cloze Test & Para Jumbles",
        "Fill in the Blanks & Vocabulary",
        "Phrase Replacement & Column Matching"
      ],
      "General Knowledge & Current Affairs": [
        "Current Affairs (Last 6-12 Months)",
        "General Knowledge & Static GK",
        "Important Awards, Appointments & Events",
        "Economic Survey & Budget Highlights"
      ],
      "Insurance & Financial Market Awareness": [
        "Insurance Sector Knowledge (IRDAI, LIC Products & Plans)",
        "Life Insurance Principles & Practices",
        "Financial Markets & Banking Concepts (RBI Policy, Stock Market)",
        "Government Insurance Schemes (PMJJBY, PMSBY, Atal Pension)",
        "Economic Survey & Union Budget Highlights"
      ]
    },
    batchInfo: "Complete AAO preparation | Interview coaching included",
  },
  {
    slug: "lic-ado",
    name: "LIC ADO",
    fullName: "Life Insurance Corporation - Apprentice Development Officer",
    category: "insurance",
    description: "LIC ADO exam is for recruitment of Development Officers who manage LIC agents and drive business growth. Our coaching provides specialized preparation for this unique marketing and leadership role within LIC.",
    eligibility: "Graduate from a recognized university. Age: 21-30 years. Relaxation applicable as per government norms.",
    examPattern: {
      prelims: { sections: [{ name: "English Language", questions: 30, marks: 30, time: "20 min" }, { name: "Quantitative Aptitude", questions: 35, marks: 35, time: "20 min" }, { name: "Reasoning Ability", questions: 35, marks: 35, time: "20 min" }], totalMarks: 100, totalTime: "60 Mins" },
      mains: { sections: [{ name: "Reasoning & Numerical Ability", questions: 50, marks: 50, time: "45 min" }, { name: "General Knowledge & Current Affairs", questions: 50, marks: 50, time: "30 min" }, { name: "English Language", questions: 50, marks: 50, time: "30 min" }, { name: "Insurance & Financial Market Awareness", questions: 50, marks: 50, time: "30 min" }], totalMarks: 200, totalTime: "135 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work",
        "Simple & Compound Interest",
        "Data Interpretation (Bar, Pie, Table, Line)",
        "Number Series"
      ],
      "Reasoning Ability": [
        "Coding-Decoding",
        "Sitting Arrangement (Linear & Circular)",
        "Syllogism & Inequality",
        "Puzzles (Floor, Box, Scheduling)",
        "Blood Relations & Direction Sense",
        "Order & Ranking"
      ],
      "English Language": [
        "Reading Comprehension",
        "Grammar (Error Detection, Sentence Correction)",
        "Vocabulary (Synonyms, Antonyms, Idioms)",
        "Fill in the Blanks & Cloze Test"
      ],
      "General Knowledge & Current Affairs": [
        "Current Affairs (National & International)",
        "General Knowledge & Static GK",
        "Government Schemes & Appointments",
        "Awards, Events & Sports"
      ],
      "Insurance & Financial Market Awareness": [
        "Insurance Principles & Practices",
        "IRDAI Regulations & Functions",
        "LIC Products, Plans & Services",
        "Marketing & Business Development Concepts",
        "Financial Markets & Banking Basics"
      ]
    },
    batchInfo: "ADO specific preparation | Combined with banking batches",
  },
  {
    slug: "gic-assistant",
    name: "GIC Assistant",
    fullName: "General Insurance Corporation - Assistant",
    category: "insurance",
    description: "GIC conducts recruitment for assistant positions in general insurance. Our coaching provides focused preparation covering all aspects of the GIC exam pattern with special emphasis on insurance awareness.",
    eligibility: "Graduate from a recognized university. Relaxation applicable as per government norms.",
    examPattern: {
      exam: { sections: [{ name: "English Language", questions: 30, marks: 30, time: "Cumulative" }, { name: "Quantitative Aptitude", questions: 35, marks: 35, time: "Cumulative" }, { name: "Reasoning Ability", questions: 35, marks: 35, time: "Cumulative" }, { name: "General Awareness", questions: 50, marks: 50, time: "Cumulative" }], totalMarks: 150, totalTime: "120 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work",
        "Simple & Compound Interest",
        "Data Interpretation (Bar, Pie, Table, Line)",
        "Number Series"
      ],
      "Reasoning Ability": [
        "Coding-Decoding",
        "Sitting Arrangement (Linear & Circular)",
        "Syllogism & Inequality",
        "Puzzles (Floor, Box, Scheduling)",
        "Blood Relations & Direction Sense"
      ],
      "English Language": [
        "Reading Comprehension",
        "Error Detection & Sentence Improvement",
        "Vocabulary (Synonyms, Antonyms, Idioms)",
        "Grammar & Fill in the Blanks"
      ],
      "General & Insurance Awareness": [
        "Current Affairs (National & International)",
        "General Knowledge & Static GK",
        "General Insurance Awareness (GIC Products, Reinsurance)",
        "IRDAI Regulations & Functions",
        "Financial Awareness & Banking Basics"
      ]
    },
    batchInfo: "Combined insurance sector preparation",
  },
  {
    slug: "gic-aao",
    name: "GIC AAO",
    fullName: "General Insurance Corporation - Assistant Administrative Officer",
    category: "insurance",
    description: "GIC AAO is an officer-level recruitment exam for General Insurance Corporation. Our coaching covers all phases with focus on insurance sector knowledge and aptitude.",
    eligibility: "Graduate with relevant qualifications. Age: 21-30 years. Relaxation applicable as per government norms.",
    examPattern: {
      exam: { sections: [{ name: "Reasoning", questions: 35, marks: 35, time: "Cumulative" }, { name: "English Language", questions: 30, marks: 30, time: "Cumulative" }, { name: "Quantitative Aptitude", questions: 35, marks: 35, time: "Cumulative" }, { name: "General Awareness", questions: 50, marks: 50, time: "Cumulative" }], totalMarks: 150, totalTime: "120 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Data Interpretation (Tables, Charts, Graphs)",
        "Data Sufficiency (Two-Statement Problems)",
        "Quadratic Equations & Number Series"
      ],
      "Reasoning Ability": [
        "Coding-Decoding",
        "Sitting Arrangement (All Types)",
        "Syllogism & Logical Deductions",
        "Puzzles (Floor, Scheduling, Multi-variable)",
        "Critical Reasoning & Statement Analysis"
      ],
      "English Language": [
        "Reading Comprehension (Passage-based, Inference)",
        "Error Spotting & Sentence Correction",
        "Vocabulary & Grammar",
        "Para Jumbles & Cloze Test"
      ],
      "General & Insurance Awareness": [
        "Current Affairs (National & International)",
        "Insurance Sector Knowledge (GIC, Reinsurance, IRDAI)",
        "Financial Markets (Stock Market, Bonds, RBI)",
        "Economic Awareness (GDP, Inflation, Budget)",
        "General Knowledge & Static GK"
      ]
    },
    batchInfo: "Officer-level insurance exam preparation",
  },
  {
    slug: "gic-ado",
    name: "GIC ADO",
    fullName: "General Insurance Corporation - Apprentice Development Officer",
    category: "insurance",
    description: "GIC ADO exam preparation with focused coaching on general insurance sector requirements and development officer responsibilities.",
    eligibility: "Graduate from a recognized university. Relaxation applicable as per government norms.",
    examPattern: {
      exam: { sections: [{ name: "Reasoning Ability", questions: 35, marks: 35, time: "Cumulative" }, { name: "Quantitative Aptitude", questions: 35, marks: 35, time: "Cumulative" }, { name: "English Language", questions: 30, marks: 30, time: "Cumulative" }, { name: "General Awareness", questions: 50, marks: 50, time: "Cumulative" }], totalMarks: 150, totalTime: "120 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Data Interpretation (Tables, Charts)",
        "Number Series"
      ],
      "Reasoning Ability": [
        "Coding-Decoding",
        "Sitting Arrangement (Linear & Circular)",
        "Syllogism & Inequality",
        "Blood Relations & Direction Sense",
        "Puzzles (Floor, Box-based)"
      ],
      "English Language": [
        "Reading Comprehension",
        "Grammar (Error Detection, Sentence Correction)",
        "Vocabulary (Synonyms, Antonyms, Idioms)"
      ],
      "General & Insurance Awareness": [
        "Current Affairs (National & International)",
        "General Insurance Awareness (GIC Products, Reinsurance)",
        "IRDAI Regulations & Functions",
        "Financial Awareness (Banking, Markets, Economy)"
      ]
    },
    batchInfo: "Combined insurance preparation batch",
  },
  {
    slug: "niacl-assistant",
    name: "NIACL Assistant",
    fullName: "New India Assurance Company Limited - Assistant",
    category: "insurance",
    description: "NIACL Assistant exam is for recruitment in New India Assurance, one of India's leading general insurance companies. Our coaching provides complete preparation with insurance-sector specific materials and mock tests.",
    eligibility: "Graduate from a recognized university. Age: 21-30 years. Relaxation applicable as per government norms.",
    examPattern: {
      prelims: { sections: [{ name: "English Language", questions: 30, marks: 30, time: "20 min" }, { name: "Quantitative Aptitude", questions: 35, marks: 35, time: "20 min" }, { name: "Reasoning Ability", questions: 35, marks: 35, time: "20 min" }], totalMarks: 100, totalTime: "60 Mins" },
      mains: { sections: [{ name: "Reasoning & Computer Aptitude", questions: 50, marks: 60, time: "45 min" }, { name: "General/Financial Awareness", questions: 50, marks: 50, time: "35 min" }, { name: "Quantitative Aptitude", questions: 50, marks: 50, time: "45 min" }, { name: "English Language", questions: 40, marks: 40, time: "35 min" }], totalMarks: 200, totalTime: "160 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work",
        "Simple & Compound Interest",
        "Data Interpretation (Bar, Pie, Table, Line)",
        "Number Series"
      ],
      "Reasoning & Computer Aptitude": [
        "Coding-Decoding",
        "Sitting Arrangement (Linear & Circular)",
        "Syllogism & Inequality",
        "Puzzles (Floor, Box, Scheduling)",
        "Blood Relations & Direction Sense",
        "Input-Output Machine",
        "Computer Fundamentals & MS Office",
        "Internet & Networking Basics"
      ],
      "English Language": [
        "Reading Comprehension",
        "Cloze Test & Error Detection",
        "Vocabulary (Synonyms, Antonyms, Idioms)",
        "Fill in the Blanks & Para Jumbles"
      ],
      "General / Financial / Insurance Awareness": [
        "Current Affairs (National & International)",
        "Insurance Awareness (NIACL Products, General Insurance)",
        "Financial Awareness (RBI, SEBI, Banking Concepts)",
        "Government Insurance Schemes & Appointments",
        "Static GK (HQs, Currencies, Capitals)"
      ]
    },
    batchInfo: "NIACL focused preparation available",
  },
  {
    slug: "niacl-aao",
    name: "NIACL AAO",
    fullName: "New India Assurance Company Limited - Administrative Officer",
    category: "insurance",
    description: "NIACL AAO exam is for officer-level positions in NIACL. Our coaching provides comprehensive preparation including interview guidance and insurance sector knowledge.",
    eligibility: "Graduate with minimum 60% marks. Age: 21-30 years. Relaxation applicable as per government norms.",
    examPattern: {
      prelims: { sections: [{ name: "English Language", questions: 30, marks: 30, time: "20 min" }, { name: "Quantitative Aptitude", questions: 35, marks: 35, time: "20 min" }, { name: "Reasoning Ability", questions: 35, marks: 35, time: "20 min" }], totalMarks: 100, totalTime: "60 Mins" },
      mains: { sections: [{ name: "Reasoning & Computer Aptitude", questions: 50, marks: 60, time: "45 min" }, { name: "Data Analysis & Interpretation", questions: 35, marks: 60, time: "45 min" }, { name: "General/Economy/Financial Awareness", questions: 40, marks: 40, time: "35 min" }, { name: "English Language", questions: 35, marks: 40, time: "40 min" }], totalMarks: 200, totalTime: "165 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude & Data Analysis": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Data Interpretation (Tables, Charts, Caselets)",
        "Data Sufficiency",
        "Quadratic Equations & Number Series"
      ],
      "Reasoning & Computer Aptitude": [
        "Coding-Decoding",
        "Sitting Arrangement (All Types)",
        "Syllogism & Inequality",
        "Puzzles (Floor, Scheduling, Multi-variable)",
        "Critical Reasoning & Machine Input-Output",
        "Computer Fundamentals, Database & Networking Basics"
      ],
      "English Language": [
        "Reading Comprehension (Passage-based, Inference)",
        "Error Spotting & Sentence Correction",
        "Cloze Test & Para Jumbles",
        "Vocabulary & Grammar"
      ],
      "General / Economy / Financial Awareness": [
        "Current Affairs (National & International)",
        "Insurance Sector Knowledge (NIACL, IRDAI, Products)",
        "Financial Markets (Stock Exchange, Bonds, RBI)",
        "Economic Awareness (GDP, Inflation, Budget, Fiscal Policy)",
        "Government Policies & Appointments"
      ]
    },
    batchInfo: "Complete AAO preparation with interview coaching",
  },
  {
    slug: "niacl-ado",
    name: "NIACL ADO",
    fullName: "New India Assurance Company Limited - Apprentice Development Officer",
    category: "insurance",
    description: "NIACL ADO exam preparation with focused coaching on general insurance sector requirements and development officer responsibilities.",
    eligibility: "Graduate from a recognized university. Age: 21-30 years. Relaxation applicable as per government norms.",
    examPattern: {
      exam: { sections: [{ name: "Reasoning Ability", questions: 35, marks: 35, time: "Cumulative" }, { name: "Quantitative Aptitude", questions: 35, marks: 35, time: "Cumulative" }, { name: "English Language", questions: 30, marks: 30, time: "Cumulative" }, { name: "General Awareness", questions: 50, marks: 50, time: "Cumulative" }], totalMarks: 150, totalTime: "120 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Data Interpretation (Tables, Charts)",
        "Number Series"
      ],
      "Reasoning Ability": [
        "Coding-Decoding",
        "Sitting Arrangement (Linear & Circular)",
        "Syllogism & Inequality",
        "Blood Relations & Direction Sense",
        "Puzzles (Floor, Box-based)"
      ],
      "English Language": [
        "Reading Comprehension",
        "Grammar (Error Detection, Sentence Correction)",
        "Vocabulary (Synonyms, Antonyms, Idioms)"
      ],
      "General & Insurance Awareness": [
        "Current Affairs (National & International)",
        "General Insurance Awareness (NIACL Products, Reinsurance)",
        "IRDAI Regulations & Functions",
        "Financial Awareness (Banking, Markets, Economy)"
      ]
    },
    batchInfo: "Combined with insurance sector preparation",
  },
  // Other Govt Exams
  {
    slug: "nabard",
    name: "NABARD",
    fullName: "National Bank for Agriculture and Rural Development",
    category: "others",
    description: "NABARD recruitment exams for various positions including Grade A and Grade B officers. Our coaching provides specialized preparation with focus on agriculture, rural development, and economic affairs knowledge unique to NABARD.",
    eligibility: "Graduate/Post-Graduate depending on the post. Relaxation applicable as per government norms.",
    examPattern: {
      prelims: { sections: [{ name: "English Language", questions: 40, marks: 40, time: "Cumulative" }, { name: "Quantitative Aptitude", questions: 20, marks: 20, time: "Cumulative" }, { name: "Reasoning", questions: 20, marks: 20, time: "Cumulative" }, { name: "General Awareness", questions: 20, marks: 20, time: "Cumulative" }, { name: "Computer Knowledge", questions: 20, marks: 20, time: "Cumulative" }, { name: "Agriculture & Rural Development", questions: 40, marks: 40, time: "Cumulative" }], totalMarks: 200, totalTime: "120 Mins" },
    },
    syllabus: {
      "English Language": [
        "Reading Comprehension (Long & Short Passages)",
        "Grammar (Error Detection, Sentence Improvement)",
        "Vocabulary (Synonyms, Antonyms, Word Usage)",
        "Para Jumbles & Cloze Test",
        "Fill in the Blanks"
      ],
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Data Interpretation (Tables, Charts, Graphs)"
      ],
      "Reasoning Ability": [
        "Coding-Decoding",
        "Syllogism & Logical Deductions",
        "Sitting Arrangement & Puzzles",
        "Blood Relations & Direction Sense"
      ],
      "General Awareness": [
        "Current Affairs (National & International)",
        "Banking & Financial Awareness (RBI, SEBI, NABARD)",
        "Economic Policy & Budget Highlights"
      ],
      "Computer Knowledge": [
        "Computer Fundamentals (Hardware & Software)",
        "MS Office (Word, Excel, PowerPoint)",
        "Internet & Networking Basics"
      ],
      "Agriculture & Rural Development": [
        "Agriculture (Major Crops, Irrigation Systems, Soil Types)",
        "Rural Development Schemes (MGNREGA, PMAY-G, PMKSY)",
        "NABARD Functions, Policies & Initiatives",
        "Microfinance & Self-Help Groups (SHGs)",
        "Farm & Non-Farm Sectors",
        "Food Security & Cooperative Banking"
      ]
    },
    batchInfo: "NABARD specialized preparation",
  },
  {
    slug: "ib-acio",
    name: "IB ACIO",
    fullName: "Intelligence Bureau - Assistant Central Intelligence Officer",
    category: "others",
    description: "IB ACIO exam is for recruitment in the Intelligence Bureau, one of India's premier intelligence agencies. Our coaching covers all aspects including general studies, aptitude, and descriptive test preparation.",
    eligibility: "Graduate from a recognized university. Age: 18-27 years. Relaxation applicable as per government norms.",
    examPattern: {
      tier1: { sections: [{ name: "General Awareness", questions: 25, marks: 25, time: "Cumulative" }, { name: "Quantitative Aptitude", questions: 25, marks: 25, time: "Cumulative" }, { name: "Logical/Analytical Ability", questions: 25, marks: 25, time: "Cumulative" }, { name: "English Language", questions: 25, marks: 25, time: "Cumulative" }], totalMarks: 100, totalTime: "60 Mins" },
      tier2: { sections: [{ name: "Descriptive English (Essay, Precis, Comprehension)", questions: 0, marks: 50, time: "Cumulative" }], totalMarks: 50, totalTime: "60 Mins" },
    },
    syllabus: {
      "General Awareness": [
        "Current Affairs (National & International, Last 6-12 Months)",
        "History (Ancient, Medieval, Modern India, Freedom Movement)",
        "Geography (India & World - Physical, Climate, Resources)",
        "Indian Polity (Constitution, Parliament, Judiciary)",
        "Economics (Indian Economy, Budget, Policy)",
        "Science & Technology (Inventions, Space, Defence)",
        "Awards, Events & Important Appointments"
      ],
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work",
        "Simple & Compound Interest",
        "Data Interpretation (Tables, Charts)"
      ],
      "Logical / Analytical Ability": [
        "Analogy & Classification",
        "Coding-Decoding",
        "Series (Number, Letter, Figure)",
        "Syllogism & Logical Reasoning",
        "Blood Relations & Direction Sense",
        "Statement & Conclusion / Assumption",
        "Logical Puzzles & Arrangements"
      ],
      "English Language": [
        "Reading Comprehension (Passage-based Q&A)",
        "Grammar (Error Detection, Sentence Correction)",
        "Vocabulary (Synonyms, Antonyms, Word Usage)",
        "Fill in the Blanks & Cloze Test"
      ],
      "Descriptive English (Tier 2)": [
        "Essay Writing (Current Topics, Social Issues)",
        "Precis Writing (Summarization Techniques)",
        "Comprehension & Analysis (Critical Reading)"
      ]
    },
    batchInfo: "Intelligence Bureau focused preparation",
  },
  {
    slug: "fci",
    name: "Food Corporation of India",
    fullName: "Food Corporation of India - Various Posts",
    category: "others",
    description: "FCI recruitment for various positions including Manager, AG-III, and JE posts. Our coaching covers all aspects of FCI exam preparation with focus on food management and agricultural awareness.",
    eligibility: "Graduate from a recognized university (varies by post). Relaxation applicable as per government norms.",
    examPattern: {
      exam: { sections: [{ name: "English Language", questions: 25, marks: 25, time: "Cumulative" }, { name: "Reasoning Ability", questions: 25, marks: 25, time: "Cumulative" }, { name: "Quantitative Aptitude", questions: 25, marks: 25, time: "Cumulative" }, { name: "General Awareness", questions: 25, marks: 25, time: "Cumulative" }], totalMarks: 100, totalTime: "60 Mins" },
    },
    syllabus: {
      "English Language": [
        "Reading Comprehension (Passage-based Q&A)",
        "Grammar (Error Detection, Sentence Improvement)",
        "Vocabulary (Synonyms, Antonyms, Word Usage)",
        "Fill in the Blanks & Cloze Test"
      ],
      "Reasoning Ability": [
        "Coding-Decoding",
        "Syllogism & Logical Deductions",
        "Series (Number, Letter, Figure)",
        "Blood Relations & Direction Sense",
        "Puzzles & Sitting Arrangement"
      ],
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work",
        "Data Interpretation (Tables, Charts)"
      ],
      "General Awareness": [
        "Current Affairs (National & International)",
        "General Knowledge & Static GK",
        "Food Management & Storage (FCI Operations)",
        "Agriculture Basics (Crops, Soil, Irrigation)",
        "Government Schemes (Food Security, PDS, PMGKAY)"
      ]
    },
    batchInfo: "FCI exam preparation available",
  },
  {
    slug: "india-post",
    name: "India Post",
    fullName: "India Post - GDS / Postman / Mail Guard",
    category: "others",
    description: "India Post conducts recruitment for GDS, Postman, Mail Guard, and other positions. Our coaching helps candidates prepare effectively for these exams. India Post offers stable government employment with excellent benefits.",
    eligibility: "10th/12th Pass depending on the post. Relaxation applicable as per government norms.",
    examPattern: {
      exam: { sections: [{ name: "Mathematics", questions: 25, marks: 25, time: "Cumulative" }, { name: "English Language", questions: 25, marks: 25, time: "Cumulative" }, { name: "General Knowledge", questions: 25, marks: 25, time: "Cumulative" }, { name: "Reasoning", questions: 25, marks: 25, time: "Cumulative" }], totalMarks: 100, totalTime: "60 Mins" },
    },
    syllabus: {
      "Mathematics": [
        "Number System (LCM, HCF, BODMAS)",
        "Percentage & Profit / Loss",
        "Ratio & Proportion",
        "Time & Work",
        "Simple & Compound Interest",
        "Averages & Mixtures"
      ],
      "English Language": [
        "Reading Comprehension (Short Passages)",
        "Grammar (Error Detection, Tenses, Articles)",
        "Vocabulary (Synonyms, Antonyms, Spelling)",
        "Fill in the Blanks & Sentence Completion"
      ],
      "General Knowledge": [
        "Current Affairs (National & International)",
        "History (Ancient, Medieval, Modern India)",
        "Geography (India - Rivers, Mountains, Climate)",
        "Indian Polity (Constitution, Governance)",
        "Science (Physics, Chemistry, Biology Basics)",
        "India Post History & Operations"
      ],
      "Reasoning Ability": [
        "Analogy & Classification",
        "Coding-Decoding",
        "Series (Number, Letter)",
        "Direction & Distance Sense",
        "Blood Relations",
        "Calendar & Clock Problems"
      ]
    },
    batchInfo: "Postal exam preparation batches",
  },
  {
    slug: "dicgc",
    name: "DICGC",
    fullName: "Deposit Insurance and Credit Guarantee Corporation",
    category: "others",
    description: "DICGC recruitment exam preparation for assistant positions. Our coaching provides focused preparation for this RBI subsidiary exam with emphasis on banking and financial knowledge.",
    eligibility: "Graduate from a recognized university. Relaxation applicable as per government norms.",
    examPattern: {
      exam: { sections: [{ name: "Reasoning", questions: 40, marks: 40, time: "Cumulative" }, { name: "English Language", questions: 30, marks: 30, time: "Cumulative" }, { name: "Quantitative Aptitude", questions: 40, marks: 40, time: "Cumulative" }, { name: "General Awareness", questions: 40, marks: 40, time: "Cumulative" }], totalMarks: 150, totalTime: "120 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work",
        "Simple & Compound Interest",
        "Data Interpretation (Tables, Charts, Graphs)"
      ],
      "Reasoning Ability": [
        "Coding-Decoding",
        "Sitting Arrangement (Linear & Circular)",
        "Syllogism & Inequality",
        "Puzzles (Floor, Box, Scheduling)",
        "Blood Relations & Direction Sense"
      ],
      "English Language": [
        "Reading Comprehension (Passage-based Q&A)",
        "Error Detection & Sentence Correction",
        "Vocabulary (Synonyms, Antonyms, Idioms)",
        "Grammar & Fill in the Blanks"
      ],
      "General & Banking Awareness": [
        "Current Affairs (National & International)",
        "Banking Awareness (RBI Functions, Policies)",
        "DICGC Functions & Deposit Insurance",
        "Financial Awareness (Markets, Economy, Budget)"
      ]
    },
    batchInfo: "Combined with banking sector preparation",
  },
  {
    slug: "epfo-esic",
    name: "EPFO / ESIC",
    fullName: "Employees' Provident Fund Organisation / Employees' State Insurance Corporation",
    category: "others",
    description: "EPFO and ESIC conduct recruitment for SSA, UDC, Stenographer, and other posts. Our coaching covers all aspects of these exams with focus on labour laws and social security awareness.",
    eligibility: "Graduate from a recognized university. Age: 18-27 years. Relaxation applicable as per government norms.",
    examPattern: {
      exam: { sections: [{ name: "General Intelligence & Reasoning", questions: 25, marks: 25, time: "Cumulative" }, { name: "General Awareness", questions: 25, marks: 25, time: "Cumulative" }, { name: "Quantitative Aptitude", questions: 25, marks: 25, time: "Cumulative" }, { name: "English Comprehension", questions: 25, marks: 25, time: "Cumulative" }], totalMarks: 100, totalTime: "60 Mins" },
    },
    syllabus: {
      "Quantitative Aptitude": [
        "Number System & Simplification",
        "Percentage, Profit & Loss",
        "Ratio & Proportion",
        "Time & Work",
        "Simple & Compound Interest",
        "Data Interpretation (Tables, Charts)"
      ],
      "General Intelligence & Reasoning": [
        "Analogy & Classification",
        "Coding-Decoding",
        "Series (Number, Letter, Figure)",
        "Syllogism & Logical Deductions",
        "Direction & Distance Sense",
        "Blood Relations"
      ],
      "General Awareness": [
        "Current Affairs (National & International)",
        "General Knowledge & Static GK",
        "Labour Laws Basics (EPF Act, ESI Act)",
        "EPFO & ESIC Functions & Schemes",
        "Social Security Schemes (Atal Pension, PM-SYM)"
      ],
      "English Comprehension": [
        "Reading Comprehension (Passage-based Q&A)",
        "Grammar (Error Detection, Sentence Correction)",
        "Vocabulary (Synonyms, Antonyms, Word Usage)",
        "Fill in the Blanks & Cloze Test"
      ]
    },
    batchInfo: "EPFO/ESIC focused batches available",
  },
  {
    slug: "bba-cet",
    name: "BBA CET",
    fullName: "Maharashtra BBA/BCA/BMS/BBM Common Entrance Test",
    category: "others",
    description: "MAH BBA CET is the state-level entrance exam for BBA, BCA, BMS, and BBM admissions in Maharashtra colleges. Perfect for 12th pass students aiming for a career in management and business administration.",
    eligibility: "12th Pass from any recognized board. Indian National. No upper age limit.",
    examPattern: {
      exam: { sections: [{ name: "Logical/Abstract Reasoning", questions: 30, marks: 30, time: "Cumulative" }, { name: "Quantitative Aptitude", questions: 30, marks: 30, time: "Cumulative" }, { name: "Verbal Ability / Reading Comprehension", questions: 30, marks: 30, time: "Cumulative" }, { name: "General Knowledge", questions: 10, marks: 10, time: "Cumulative" }], totalMarks: 100, totalTime: "90 Mins" },
    },
    syllabus: {
      "Logical & Abstract Reasoning": [
        "Logical Reasoning (Arrangements, Syllogism, Blood Relations)",
        "Abstract Reasoning (Figure Series, Pattern Recognition)",
        "Visual Analogy & Odd One Out",
        "Coding-Decoding & Direction Sense",
        "Mirror & Water Image, Paper Folding",
        "Embedded Figures & Pattern Completion"
      ],
      "Quantitative Aptitude": [
        "Number System (LCM, HCF, BODMAS)",
        "Percentage & Profit / Loss",
        "Ratio & Proportion",
        "Time & Work",
        "Algebra Basics (Linear Equations)",
        "Geometry Basics (Triangles, Circles)",
        "Data Interpretation (Tables, Charts)"
      ],
      "Verbal Ability & Reading Comprehension": [
        "Reading Comprehension (Short & Long Passages)",
        "Grammar (Tenses, Articles, Prepositions, Subject-Verb Agreement)",
        "Vocabulary (Synonyms, Antonyms, Word Usage)",
        "Sentence Correction & Improvement",
        "Para Jumbles & Sentence Rearrangement"
      ],
      "General Knowledge": [
        "Current Affairs (National & International)",
        "Business & Economy Basics",
        "Science & Technology Developments",
        "Awards, Events & Sports",
        "Indian History & Geography Basics"
      ]
    },
    batchInfo: "BBA CET focused coaching | Ideal for 12th students",
  },
];

export const getCourseBySlug = (slug) => courses.find((c) => c.slug === slug);
export const getCoursesByCategory = (categoryId) => courses.filter((c) => c.category === categoryId);
